export const CommunicationTypes = Object.freeze({
	email: "email",
	sms: "sms"
});
